<div class="app-bar">
  <a class="link" href="https://plusmore.co.za/" target="_blank" rel="noopener noreferrer">
    <img class="logo" src="assets\images\plusmore_logo.svg" />
  </a>
</div>
